export default {
    cz: {
        seasonPoints: {
            title: 'Za nákup tohoto produktu získáte ve věrnostním programu',
            text: (
                <>
                    Podívejte se,
                    {' '}
                    <a href="#">co všechno můžete získat</a>
                    {' '}
                    za nasbírané body.
                </>
            ),
        },
        gift: {
            title: 'Skvělá volba!',
            text: 'K tomuto produktu od nás dostanete navíc dárek.',
        },
    },
    sk: {
        seasonPoints: {
            title: 'Za nákup tohoto produktu získáte ve věrnostním programu',
            text: (
                <>
                    Podívejte se,
                    {' '}
                    <a href="#">co všechno můžete získat</a>
                    {' '}
                    za nasbírané body.
                </>
            ),
        },
        gift: {
            title: 'Skvělá volba!',
            text: 'K tomuto produktu od nás dostanete navíc dárek.',
        },
    },
}
